module.exports = __webpack_public_path__ + "static/media/fall.601efb47.jpg";